module.exports = __webpack_public_path__ + "static/wordpress-49f23ea55b2d323437541a82e134ec32.png";